import { ClientOnlyPortal } from '@components/ClientOnly'
import { PropsWithChildren } from 'react'
import styles from './index.module.sass'

function ModalWrapper ({ children }: PropsWithChildren<unknown>) {
  return (
    <ClientOnlyPortal selector="#modal">
      <div className={styles.modalWrapper}>{children}</div>
    </ClientOnlyPortal>
  )
}

export default ModalWrapper
